import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

export const CategoryItem = ({
  category,
  toggleCategory,
  routerPath,
  openedCategories,
  activedCategory,
  categories,
  currentLanguage,
  toggleCategorySidebar,
  isNewsOpen
}) => {
  let open = openedCategories.find(oc => parseInt(oc) === category.id)
    ? ' open'
    : ''
  let active = activedCategory === category.id && !isNewsOpen ? ' active' : ''
  return (
    <li
      className={
        'sidebar__menu__item ' +
          (category.hasChild ? ' has-subs' : '') +
          active +
          open
      }
    >
      <Link
        to={'/' + routerPath + '/' + category.route[currentLanguage].route}
        id={category.id}
        onClick={() => { toggleCategory(category.id, null); toggleCategorySidebar(false) }}
      >
        {category.route[currentLanguage].title}
      </Link>
      {category.hasChild
        ? <span
          className='sidebar__menu__item__control'
          onClick={() => toggleCategory(category.id, null)}
          />
        : ''}
      {openedCategories.findIndex(oc => oc === category.id) !== -1
        ? <ul>
          {categories
              .filter(c => c.parent === category.id)
              .map((subcategory, index) => (
                <li
                  className={
                    (activedCategory === subcategory.id ? 'active' : '') +
                      ' sidebar__menu__item'
                  }
                  key={index}
                >
                  <Link
                    to={
                      '/' +
                        routerPath +
                        '/' +
                        category.route[currentLanguage].route +
                        '/' +
                        subcategory.route[currentLanguage].route
                    }
                    id={subcategory.id}
                    onClick={() => { toggleCategory(subcategory.id, category.id); toggleCategorySidebar(false) }}
                  >
                    {subcategory.route[currentLanguage].title}
                  </Link>
                </li>
              ))}
        </ul>
        : ''}
    </li>
  )
}

CategoryItem.defaultProps = { title: 'Kategoria', hasChild: false }
CategoryItem.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    hasChild: PropTypes.bool,
    parent: PropTypes.number,
  }).isRequired,
  categories: PropTypes.array,
  openedCategories: PropTypes.array,
  activedCategory: PropTypes.number,
  toggleCategory: PropTypes.func,
  toggleCategorySidebar: PropTypes.func,
  routerPath: PropTypes.string.isRequired,
  currentLanguage: PropTypes.string.isRequired
}

export default CategoryItem



// WEBPACK FOOTER //
// ./src/components/CategoryItem.js